// this file is automatically generated by git.revision.js script
export const versions = { revision: 'aecf0328f8' }; 
 //expose the commit hash to the window object 
//@ts-ignore 
window.rd_version = 'aecf0328f8';
